import React from 'react';
import { colors } from '@guryou/colors';
import { Block, ContainedButton, FlexRow, Form, HiddenField, LargeText, TextAreaBox, TextBox } from '@guryou/html-components';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ModernButton from './ModernButton';
import ModernDropdown from './ModernDropdown';

const ExerciseManagementForm = ({
  handleSubmit,
  exercise,
  setExercise,
  allExercises,
  handleExerciseSelect,
  creationMode,
  setCreationMode,
  exerciseId,
  levels,
  muscles,
  equipments,
}) => {
  return (
    <>
      <LargeText fontWeight="700" width="fit-content" margin="0 auto" marginBottom={10} color={colors.white}>
        Create Exercise
      </LargeText>

      {!exerciseId && creationMode === null && (
        <FlexRow justifyContent="center">
          <div style={{ marginRight: '16px' }}>
            <ModernButton onClick={() => setCreationMode('scratch')} text="Create From Scratch" isActive={creationMode === 'scratch'} />
          </div>
          <div>
            <ModernButton onClick={() => setCreationMode('select')} text="Select From Existing" isActive={creationMode === 'select'} />
          </div>
        </FlexRow>
      )}

      {creationMode === 'select' && !exerciseId && (
        <div style={{ width: '50%', margin: '16px auto' }}>
          <ModernDropdown
            label="Select an Exercise"
            options={allExercises?.map(ex => ({ value: ex.id, label: ex.name })) || []}
            onChange={handleExerciseSelect}
          />
        </div>
      )}

      {(creationMode === 'scratch' || (exerciseId && creationMode === null)) && (
        <Form actions={false} onSubmit={handleSubmit} parserVersion={2}>
          <HiddenField name="id" value={exercise?.id} />

          <FlexRow alignItems="flex-start" style={{ marginBottom: '40px' }}>
            <div style={{ flex: 1, marginRight: '8px' }}>
              <TextBox
                key={exercise?.name || '1'}
                name="name"
                label="Name"
                required={true}
                value={exercise?.name}
                InputLabelProps={{ style: { color: 'white' } }}
                inputProps={{ style: { color: 'white' } }}
              />
            </div>
            <div style={{ flex: 1, marginLeft: '8px', marginRight: '8px' }}>
              <TextAreaBox
                label="Description"
                name="description"
                defaultValue={exercise?.description}
                withToolbar={false}
                InputLabelProps={{ style: { color: 'white' } }}
                inputProps={{ style: { color: 'white' } }}
              />
            </div>
            <div style={{ flex: 1, marginLeft: '8px', display: 'flex', alignItems: 'start', flexDirection: 'column' }}>
              <FormControlLabel
                control={<Checkbox name="is_public" value="true" color="primary" style={{ color: 'white' }} defaultChecked={!!exercise?.is_public} />}
                label={<span style={{ color: 'white' }}>Is Public</span>}
              />
              <FormControlLabel
                control={
                  <Checkbox name="use_weights" value="true" color="primary" style={{ color: 'white' }} defaultChecked={!!exercise?.use_weights} />
                }
                label={<span style={{ color: 'white' }}>Use Weights</span>}
              />
            </div>
          </FlexRow>

          <FlexRow alignItems="center" style={{ marginBottom: '40px' }}>
            <div style={{ flex: 1, marginRight: '8px' }}>
              <ModernDropdown
                label="Difficulty"
                options={levels}
                value={exercise?.level}
                onChange={value => setExercise({ ...exercise, level: value })}
              />
            </div>
            <div style={{ flex: 1, marginLeft: '8px', marginRight: '8px' }}>
              <ModernDropdown
                label="Muscle Area"
                options={muscles}
                value={exercise?.muscle_area}
                onChange={value => setExercise({ ...exercise, muscle_area: value })}
              />
            </div>
            <div style={{ flex: 1, marginLeft: '8px' }}>
              <ModernDropdown
                label="Equipment"
                options={equipments.map(eq => ({ value: eq.id, label: eq.name })) || []}
                value={exercise?.equipment_ids}
                onChange={value => setExercise({ ...exercise, equipment_ids: value })}
                isMultiSelect
              />
            </div>
          </FlexRow>

          <Block textAlign="center" marginTop={4} marginBottom={4}>
            <ContainedButton type="submit" text={exerciseId ? 'Save' : 'Create'} />
          </Block>
        </Form>
      )}
    </>
  );
};

export default ExerciseManagementForm;
